<template>
	<div class="app-text-field">
		<v-text-field ref="input_ref" :hide-details="hideDetails" v-bind="$attrs" v-on="$listeners" solo flat>
			<template v-for="(_, slot) of $scopedSlots" v-slot:[slot]="scope"><slot :name="slot" v-bind="scope" /></template>
		</v-text-field>
	</div>
</template>

<script>
export default {
	name: 'AppTextField',
	props: { hideDetails: { type: Boolean, default: true } },
	methods: {
		focus() {
			this.$refs.input_ref.focus();
		},
	},
};
</script>

<style scoped lang="scss">
.app-text-field {
}
</style>
